import { Box, Card, Grid, Typography } from '@mui/material'
import HeaderGestorConfigs from '../../../utils/headerGestorConfigs'
import DateHora from '../../../utils/dateHora'
import TextoFormatado from '../../../utils/textoFormatado';
import Date from '../../../utils/date';
import Genero from '../../../utils/genero';
import StatusSolicitacoes from '../../../utils/status/statusSolicitacoes';

export default function FichaSolicitacaoAnalise({ solicitacaoAnalise }) {

    const renderField = (label, value) => (
        <Grid item xs={12} sm={6}>
            <Box>
                <Typography variant="caption" color="text.secondary">
                    {label}
                </Typography>
                <Typography variant="body1">
                    {value || 'Não informado'}
                </Typography>
            </Box>
        </Grid>
    );
    return (
        <Card style={{ padding: 20, position: 'relative' }}>

            <HeaderGestorConfigs
                menu={false}
                configArea={''}
                title={'SOLICITAÇÃO DE ANÁLISE'}
            />

            <Box>
                <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                    <Grid container spacing={1}>
                        {renderField('Estado', <StatusSolicitacoes status={solicitacaoAnalise?.status} />)}
                        {renderField('Número de registo', solicitacaoAnalise?.numero)}
                        {renderField('Solicitado por', solicitacaoAnalise?.remetidoPor?.nome)}
                        {renderField('Tipo de remetente', solicitacaoAnalise.remetidoPor.bi)}
                        {renderField('Tipo de remetente', solicitacaoAnalise?.tipoRemetente)}
                        {renderField('Quantidade de produtos', solicitacaoAnalise?.productos?.length)}
                        {renderField('Grau de urgência', solicitacaoAnalise?.grauUrgencia ?? 'Urgente')}
                        {renderField('Data de Solicitação', <DateHora date={solicitacaoAnalise.createdAt} />)}
                    </Grid>
                </Box>

                <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                    <Typography variant="h6" sx={{ mb: 3, color: 'text.primary' }}>
                        Dados do Remetente
                    </Typography>
                    <Grid container spacing={1}>
                        {renderField('Tipo de Remetente', solicitacaoAnalise.tipoRemetente)}
                        {renderField('Nome', solicitacaoAnalise.nome)}
                        {renderField('NIF/BI', solicitacaoAnalise.nifBi)}
                        {renderField('Email', solicitacaoAnalise.email)}
                        {renderField('Telefone', solicitacaoAnalise.tel)}
                        {renderField('Província', solicitacaoAnalise.provincia)}
                        {renderField('Município', solicitacaoAnalise.municipio)}
                        {renderField('Bairro', solicitacaoAnalise.bairro)}
                        {renderField('Rua', solicitacaoAnalise.rua)}
                        {solicitacaoAnalise.estabelecimento && (
                            <>
                                {renderField('Estabelecimento', solicitacaoAnalise.estabelecimento.nome)}
                                {renderField('NIF do Estabelecimento', solicitacaoAnalise.estabelecimento.nif)}
                                {renderField('Número do Processo', solicitacaoAnalise.estabelecimento.numeroProcesso)}
                                {renderField('Status', solicitacaoAnalise.estabelecimento.status)}
                            </>
                        )}
                    </Grid>
                </Box>

                {/* Nova seção: Dados do Responsável */}

                <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                    <Typography variant="h6" sx={{ mb: 3, color: 'text.primary' }}>
                        Dados do Responsável
                    </Typography>
                    <Grid container spacing={1}>
                        {renderField('Nome do Responsável', solicitacaoAnalise.remetidoPor.nome)}
                        {renderField('Telefone do Responsável', solicitacaoAnalise.remetidoPor.tel)}
                        {renderField('Email do Responsável', solicitacaoAnalise.remetidoPor.email)}
                        {renderField('BI do Responsável', solicitacaoAnalise.remetidoPor.bi)}
                        {renderField('Data de Nascimento', <Date date={solicitacaoAnalise.remetidoPor.dataNascimento} />)}
                        {renderField('Gênero', <Genero genero={solicitacaoAnalise.remetidoPor.genero} />)}
                    </Grid>
                </Box>
            </Box>

            <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Justificativa:</strong> <TextoFormatado texto={solicitacaoAnalise?.justificativa ?? '####'} /></Typography>
            </Box>

            {/* 
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Estado:</strong> {solicitacaoAnalise?.status ?? '####'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Numero de registo:</strong> {solicitacaoAnalise?.numero ?? '####'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Solicitado por:</strong> {solicitacaoAnalise?.remetidoPor?.nome ?? '####'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Tipo de remetente:</strong> {solicitacaoAnalise?.tipoRemetente ?? '####'}</Typography>
            <br />
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Remetente</strong> </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">Nome: {solicitacaoAnalise?.remetidoPor.nome ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">Telefone: {solicitacaoAnalise?.remetidoPor.tel ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">E-mail: {solicitacaoAnalise?.remetidoPor.email ?? '####'} </Typography>
            <br />
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Entidade</strong> </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">Nome: {solicitacaoAnalise?.nome ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">NIF / B.I: {solicitacaoAnalise?.nifBi ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">Telefone: {solicitacaoAnalise?.tel ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">E-mail: {solicitacaoAnalise?.email ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">provincia: {solicitacaoAnalise?.provincia ?? '####'} </Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1">Município: {solicitacaoAnalise?.municipio ?? '####'} </Typography>
            <br />
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Quantidade de produtos:</strong> {solicitacaoAnalise?.productos?.length ?? '####'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Grau de urgência:</strong> {solicitacaoAnalise?.grauUrgencia ?? 'Urgente'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Data de Solicitação:</strong> <DateHora date={solicitacaoAnalise.createdAt} /></Typography> */}
        </Card>
    )
}
